import { useEffect, useState, useContext } from "react";
import authContext from "contexts/auth/authContext";
import { useSettings } from "../use-settings";
import { isEmpty } from "lodash";

function parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = decodeURIComponent(
        atob(base64Url)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );

    return JSON.parse(base64);
}

export const useAllowedRoles = (allowedRoles, checkAllowedRoutes, currentRoute, checkPermission) => {
    const { user } = useContext(authContext);
    const { settings } = useSettings();
    const [state, setState] = useState({ isProcessing: true, isAllowed: false });
    const token = localStorage.getItem("access_token");

    useEffect(() => {
        const fetchEnvironment = () => {
            const grantedPermissions = settings.routePermissions;
            const roles = settings.globalSettings.roles;
            const environment = roles[settings.globalSettings.environment] ? roles[settings.globalSettings.environment] : "Intake-";

            if ((!allowedRoles || allowedRoles.length < 1) && !checkAllowedRoutes) {
                return true;
            }

            if (isEmpty(grantedPermissions)) {
                setState({ isProcessing: true, isAllowed: false });

                return;
            }

            if (checkAllowedRoutes && currentRoute) {
                const hasRoutePermission = grantedPermissions.find((allowed) => allowed.route === currentRoute);
                const isUserAllowedToRoute = user.permissions.some((currentPerms) => {
                    return currentPerms.name === hasRoutePermission.permission;
                });
                setState({ isProcessing: false, isAllowed: isUserAllowedToRoute });

                return;
            }

            if (!checkAllowedRoutes && checkPermission) {
                const check = user.permissions.some((currentPerms) => {
                    return allowedRoles === currentPerms.name;
                });

                setState({ isProcessing: false, isAllowed: check });

                return;
            }

            const mergedRoleNames = allowedRoles.map((allowedRole) => `${environment}${allowedRole}`);
            const grantedRoles = parseJwt(token)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

            if (!grantedRoles) {
                setState({ isProcessing: false, isAllowed: false });

                return;
            }

            const hasPermission = grantedPermissions.some((allowed) => {
                return user.permissions.some((currentPerms) => {
                    return allowed.permission === currentPerms.name;
                });
            });

            if (checkAllowedRoutes) {
                setState({ isProcessing: false, isAllowed: hasPermission });

                return;
            }

            const hasPriv = grantedRoles.some((role) => {
                return mergedRoleNames.some((currentRole) => {
                    return role === currentRole;
                });
            });

            setState({ isProcessing: false, isAllowed: hasPriv });
        };

        fetchEnvironment();
    }, [allowedRoles, settings, user]);

    return state;
};
